import React from "react";
import * as Haptics from "expo-haptics";
import { useTheme } from "arkh";
import Animated, {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import { TouchableWithoutFeedback } from "react-native-gesture-handler";
import { Platform } from "react-native";

export function CameraButton({
  onPress,
  size,
}: {
  onPress(): void;
  size: number;
}) {
  const theme = useTheme();
  const cameraButtonAnimation = useSharedValue(0);
  const cameraButtonAnimatedStyle = useAnimatedStyle(() => ({
    transform: [
      {
        scale: interpolate(cameraButtonAnimation.value, [0, 1], [1, 0.8]),
      },
    ],
  }));

  return (
    <TouchableWithoutFeedback
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        borderWidth: 4,
        alignItems: "center",
        justifyContent: "center",
        borderColor: theme.surface,
      }}
      onPressIn={() => {
        cameraButtonAnimation.value = withTiming(1, { duration: 300 });
      }}
      onPressOut={() => {
        if (Platform.OS === "ios") {
          Haptics.impactAsync(Haptics.ImpactFeedbackStyle.Light);
        }
        onPress();
        cameraButtonAnimation.value = withTiming(0, { duration: 300 });
      }}
    >
      <Animated.View
        style={[
          {
            width: size - 14,
            height: size - 14,
            borderRadius: (size - 14) / 2,
            backgroundColor: theme.surface,
          },
          cameraButtonAnimatedStyle,
        ]}
      />
    </TouchableWithoutFeedback>
  );
}
